import { Station } from '@mi-front/core';
import { Suspense } from 'react';
import { YoutubeRecentBroadcastsContent } from './YoutubeRecentBroadcastsContent';
import { YoutubeRecentBroadcastsShell } from './YoutubeRecentBroadcastsShell';

interface YoutubeNativeRecentTransmissionsProps {
  station: Station;
}

/** Recent YouTube Native transmissions panel shown when the station is offline. */
export function YoutubeRecentBroadcasts({ station }: YoutubeNativeRecentTransmissionsProps) {
  return (
    <Suspense fallback={<YoutubeRecentBroadcastsShell loading stationSlug={station.slug} />}>
      <YoutubeRecentBroadcastsContent station={station} />
    </Suspense>
  );
}
